export default "__VITE_ASSET__B0XMn94f__"